import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { getUnitMeasurementByCode } from '../../slices/thunks';


const useUnitMeasurement = (code) => {
    const dispatch = useDispatch();

    const selector = createSelector(
        state => state.UnitMeasurements,
        unitMeasurement => ({
            dataUnitMeasurement: unitMeasurement.dataUnitMeasurement
        })
    );

    const { dataUnitMeasurement } = useSelector(selector);

    useEffect(() => {
        dispatch(getUnitMeasurementByCode(code));
    }, [dispatch]);
    return {dataUnitMeasurement};
}

export default useUnitMeasurement;